module.exports = __webpack_public_path__ + "static/Nmo_logo-0bbe44ad0e05269e24c8629927399eb3.png";